/* eslint-disable react/prop-types */
import React, { useState } from 'react';

export default function Faq({ question, answer, id, defaultOpen = false }) {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <div className={`faq-item ${isOpen ? 'open' : ''}`}>
      <div className="faq-item-bar" aria-hidden="true" />
      <button className="faq-trigger" onClick={() => setIsOpen((o) => !o)} aria-expanded={isOpen}>
        <span className="faq-trigger-text">{question}</span>
        <span className="faq-icon-wrap" aria-hidden="true">
          <span className="faq-icon" />
        </span>
      </button>
      <div className="faq-body" role="region">
        <div className="faq-body-inner">{answer}</div>
      </div>
    </div>
  );
}
